import { render, staticRenderFns } from "./NewUserPopUp.vue?vue&type=template&id=a5e09d2c&"
import script from "./NewUserPopUp.vue?vue&type=script&lang=js&"
export * from "./NewUserPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports